const A = "https://customer-assets-0z36b82j.emergentagent.net/job_ea057120-edd4-4c74-b9c7-4cde62ec473d/artifacts";
const B = "https://customer-assets-lxgj4vgw.emergentagent.net/job_tboi-wedding-hub/artifacts";

export const IMG = {
  redBed: `${A}/evde9udd_PHOTO-2026-08-26-04-23-18.jpg`,
  ceremony: `${A}/atny3wkf_PHOTO-2026-08-26-04-23-17.jpg`,
  pastelFire: `${A}/mhcgt4cs_PHOTO-2026-08-26-04-23-17%202.jpg`,
  pinkSherwani: `${A}/jsmjo00j_PHOTO-2026-08-26-04-23-16.jpg`,
  beach: `${A}/wpuhypkz_PHOTO-2026-08-26-04-15-43.jpg`,
  bride1: `${B}/goato4vs_PHOTO-2026-08-26-05-02-45.jpg`,
  bride2: `${B}/x5q42bzz_PHOTO-2026-08-26-05-00-50.jpg`,
  bride3: `${B}/658jzivu_PHOTO-2026-08-26-05-04-20.jpg`,
  bride4: `${B}/qkvggy3y_PHOTO-2026-08-26-05-03-51.jpg`,
  bride5: `${B}/z3smxcl4_PHOTO-2026-08-26-05-03-09.jpg`,
  fashion1: `${B}/ikrodz94_PHOTO-2026-08-26-05-00-49.jpg`,
  fashion2: `${B}/i4mpyd4p_PHOTO-2026-08-26-05-00-49%202.jpg`,
  fashion3: `${B}/czg7i29o_PHOTO-2026-08-26-04-59-21.jpg`,
  fashion4: `${B}/pszlcja5_PHOTO-2026-08-26-04-59-21%202.jpg`,
  fashion5: `${B}/9xpuc5l9_PHOTO-2026-08-26-04-59-20.jpg`,
  scenic1: `${B}/fxb635gb_PHOTO-2026-08-26-04-53-55.jpg`,
  scenic2: `${B}/70kssnd2_PHOTO-2026-08-26-04-53-55%202.jpg`,
  scenic3: `${B}/r7acaw28_PHOTO-2026-08-26-04-52-33.jpg`,
  scenic4: `${B}/of8aoftd_PHOTO-2026-08-26-04-59-19.jpg`,
  scenic5: `${B}/d14urpyl_PHOTO-2026-08-26-04-53-55%203.jpg`,
  fireworks: "https://images.pexels.com/photos/28120538/pexels-photo-28120538.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  mandap: "https://images.unsplash.com/photo-1700728319869-7ca4d95806b9?crop=entropy&cs=srgb&fm=jpg&q=85",
  florals: "https://images.unsplash.com/photo-1607861876572-07754b7bba0d?crop=entropy&cs=srgb&fm=jpg&q=85",
};
